// @flow

import { observer } from "mobx-react";
import React from "react";

import User from "app/models/User";

import TextFormatter from "app/util/TextFormatter";

import VideoDelete from "app/components/VideoDelete/VideoDelete";
import VideoPublish from "app/components/VideoPublish/VideoPublish";

import Video from "app/models/Video";

import "./VideoStatus.scss";

type Props = {
    user?: ?User,
    video: Video,
    lastVersion: number,
    lastPublishedVersion: ?number,
    lastSaved: ?Date,
    publishable: boolean,
    onPublish: Function,
    deleting: boolean,
    onDelete: Function
};

@observer
export default class VideoStatus extends React.Component<Props> {
    render() {
        let classes = ["VideoStatus"];
        if(!this.props.video.isPublished) {
            classes.push("VideoStatus--published");
        }

        return (
            <div className={classes.join(" ")}>
                {this.renderHeader()}

                <div className="VideoStatus__actions clearfix">
                    {this.renderPublish()}
                    {this.renderDraftButton()}
                    {this.renderDeleteButton()}
                </div>
            </div>
        );
    }

    renderHeader() {
        const lastPublished = this.renderLastPublished();
        const lastSaved = this.renderLastSaved();

        if (!lastPublished && !lastSaved) return null;

        return (
            <header className="VideoStatus__header">
                {lastPublished}
                {lastSaved}
            </header>
        );
    }

    renderLastPublished() {
        const video = this.props.video;
        const lastPublishedVersion = this.props.lastPublishedVersion;

        if (video.isPublished || !lastPublishedVersion) return null;

        const url = `/watch?tlv=${video.uid}&r=${lastPublishedVersion}`;

        return (
            <a className="VideoStatus__lastPublished" href={url}>
                <span className="glyphicon glyphicon-new-window" /> Your current
                live version
            </a>
        );
    }

    renderDraftButton() {
        const video = this.props.video;
        if (!video.isPublished) return null;

        const url = `/video/${video.uid}/draft`;

        return (
            <a className="VideoStatus__draft" href={url}>
                <i className="fa fa-pencil" /> Edit this video
            </a>
        );
    }

    renderDeleteButton() {
        const video = this.props.video;
        if (!this.props.user || video.isPublished) return null;

        return <VideoDelete onDelete={this.props.onDelete} />;
    }

    renderLastSaved() {
        const video = this.props.video;
        if (video.isPublished) return null;

        const lastSaved = TextFormatter.dateTime(
            this.props.lastSaved || video.updated_at
        );

        return (
            <div className="VideoStatus__lastSaved">
                <i className="fa fa-check" /> Draft Last saved: {lastSaved}
            </div>
        );
    }

    renderPublish() {
        if (!this.props.publishable) return null;

        let enabled =
            this.props.lastSaved ||
            this.props.video.created_at.toISOString() !==
                this.props.video.updated_at.toISOString();

        return (
            <VideoPublish onClick={this.props.onPublish} disabled={!enabled} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoStatus/VideoStatus.js